import React, { useState } from 'react';
import { ChevronDown, LogOut, User, Settings } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';

const UserDropdown = ({ user = { name: 'Admin User', email: 'admin@fosen.com' } }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { logout, user: sessionUser } = useAdmin();
  const displayUser = sessionUser || user;

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-3 px-3 py-2 hover:bg-gray-100 rounded-lg transition"
      >
        <div className="w-8 h-8 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center text-white font-semibold text-sm">
          {displayUser.name.split(' ').map(n => n[0]).join('').toUpperCase()}
        </div>
        <ChevronDown size={18} className="text-gray-600" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
              className="fixed inset-0 z-40"
            />
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute right-0 mt-2 w-56 max-w-[calc(100vw-1rem)] bg-white dark:bg-[#241b14] rounded-2xl shadow-xl border border-gray-100 dark:border-[#3e2f20] z-50 overflow-hidden"
            >
              <div className="p-4 border-b border-gray-100 dark:border-[#3e2f20] bg-[#fff9f1] dark:bg-[#1c1510]">
                <p className="text-sm font-bold text-[#2c200f] dark:text-[#f8efe5] truncate">{displayUser.name}</p>
                <p className="text-xs text-[#7e6d54] dark:text-[#d8c3aa] truncate">{displayUser.email}</p>
              </div>

              <div className="p-2 space-y-1">
                <button
                  onClick={() => {
                    navigate('/admin/profile');
                    setIsOpen(false);
                  }}
                  className="w-full flex items-center gap-3 px-3 py-2 text-[#4d3d2c] dark:text-[#f8efe5] hover:bg-[#fff9f1] dark:hover:bg-[#2e2218] rounded-xl transition text-xs sm:text-sm font-medium"
                >
                  <User size={16} className="text-[#E8B530]" />
                  My Profile
                </button>
                <button
                  onClick={() => {
                    navigate('/admin/settings');
                    setIsOpen(false);
                  }}
                  className="w-full flex items-center gap-3 px-3 py-2 text-[#4d3d2c] dark:text-[#f8efe5] hover:bg-[#fff9f1] dark:hover:bg-[#2e2218] rounded-xl transition text-xs sm:text-sm font-medium"
                >
                  <Settings size={16} className="text-[#E8B530]" />
                  Settings
                </button>
              </div>

              <div className="p-2 border-t border-gray-100 dark:border-[#3e2f20]">
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-3 py-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/40 rounded-xl transition text-xs sm:text-sm font-medium"
                >
                  <LogOut size={16} />
                  Logout
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default UserDropdown;
